import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter as faFilterSolid } from '@fortawesome/pro-solid-svg-icons';
import { faFilter } from '@fortawesome/pro-regular-svg-icons';
import { isEmpty } from 'lodash';

import {
  setCurrentPage,
  fetchSnapshotStats,
  resetCurrentPage,
  resetCurrentTab,
  toggleDisplayOverlay,
  toggleAutoUpdate,
} from '../actions';
import { usePage } from '../../../helpers/hooks';

import EventSelectorButton from '../../../components/EventSelector/Button';
import EventSelector from '../../../components/EventSelector/Modal';
import Stats from '../AlbumController/Stats';
import env from '../../../config/env';
import AlbumPhotoContainer from '../AlbumPhotoContainer';
import FilterForm from '../FilterForm';
import MultiSnapshotControls from '../MultiSnapshotControls';

import style from './style.module.scss';

const MOBILE_BREAKPOINT = 767;

const AlbumMobile = (props) => {
  const {
    selectedEvents,
    selectedEventsPage,
    setCurrentPageAction,
    fetchSnapshotStatsAction,
    resetCurrentPageAction,
    resetCurrentTabAction,
    overlaysDisplayed,
    autoUpdateEnabled,
    toggleDisplayOverlayAction,
    toggleAutoUpdateAction,
    filterData,
  } = props;

  const page = usePage();
  const [filtersModalOpen, setFiltersModalOpen] = useState(false);

  useEffect(() => {
    if (selectedEventsPage === page) {
      fetchSnapshotStatsAction();
      setCurrentPageAction(1);
    }
  }, [selectedEvents, selectedEventsPage]);

  useEffect(() => () => {
    resetCurrentPageAction();
    resetCurrentTabAction();
  }, []);

  const openFilters = () => setFiltersModalOpen(true);
  const closeFilters = () => setFiltersModalOpen(false);

  return (
    <div className={style.AlbumMobilePage}>
      <MultiSnapshotControls />

      <header className={style.MobileHeader}>
        <div className={style.HeaderRow}>
          <h2 className={style.Title}>Album</h2>
          <EventSelectorButton />
        </div>

        <div className={style.TogglesRow}>
          {!env.isSelfieCam() && (
            <label htmlFor="album-mobile-overlays" className={classNames(style.SwitchLabel, { [style.SwitchLabelOn]: overlaysDisplayed })}>
              <input
                id="album-mobile-overlays"
                type="checkbox"
                checked={overlaysDisplayed}
                className="switcher-input"
                onChange={toggleDisplayOverlayAction}
              />
              <span className="switcher-indicator">
                <span className="switcher-yes" />
                <span className="switcher-no" />
              </span>
              <span className="switcher-label">Overlays</span>
            </label>
          )}
          <label htmlFor="album-mobile-auto-refresh" className={classNames(style.SwitchLabel, { [style.SwitchLabelOn]: autoUpdateEnabled })}>
            <input
              id="album-mobile-auto-refresh"
              type="checkbox"
              checked={autoUpdateEnabled}
              className="switcher-input"
              onChange={toggleAutoUpdateAction}
            />
            <span className="switcher-indicator">
              <span className="switcher-yes" />
              <span className="switcher-no" />
            </span>
            <span className="switcher-label">Auto refresh</span>
          </label>
          <Button
            variant="link"
            className={style.FiltersButton}
            disabled={selectedEvents.length === 0}
            onClick={openFilters}
          >
            {Object.values(filterData).every((val) => isEmpty(val))
              ? <FontAwesomeIcon icon={faFilter} />
              : <FontAwesomeIcon icon={faFilterSolid} />}
            <span>Filters</span>
          </Button>
        </div>

        <div className={style.TabsRow}>
          <div className={style.TabsScroll}>
            <Stats />
          </div>
        </div>
      </header>

      <main className={style.MainContent}>
        <div className={style.Snapshots} data-mobile-album>
          <AlbumPhotoContainer />
        </div>
      </main>

      <EventSelector />

      <Modal
        show={filtersModalOpen}
        onHide={closeFilters}
        className={style.FiltersModal}
        dialogClassName={style.FiltersModalDialog}
      >
        <Modal.Header closeButton>
          <Modal.Title>Filters</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FilterForm />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={closeFilters}>
            Done
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default connect(
  ({
    album: {
      options: { overlaysDisplayed, autoUpdateEnabled },
      filterForm: { data: filterData },
    },
    events: { selectedEvents, selectedEventsPage },
  }) => ({
    selectedEvents,
    selectedEventsPage,
    overlaysDisplayed,
    autoUpdateEnabled,
    filterData,
  }),
  {
    setCurrentPageAction: setCurrentPage,
    fetchSnapshotStatsAction: fetchSnapshotStats,
    resetCurrentPageAction: resetCurrentPage,
    resetCurrentTabAction: resetCurrentTab,
    toggleDisplayOverlayAction: toggleDisplayOverlay,
    toggleAutoUpdateAction: toggleAutoUpdate,
  },
)(AlbumMobile);

export { MOBILE_BREAKPOINT };
